import React, { useEffect, useState, useRef } from "react";
import nanoid from "nanoid";

import { queryDwLayerCanopyPropertyData, queryDwLayerPigmentPropertyData, queryDwLayerHeightPropertyData, queryDwLayerVigorPropertyData, queryDwLayerRowCol, queryDwLayerBloomPropertyData, queryDwLayerCultivarPropertyData, queryDwLayerStatusData, queryDwLayerTreatmentPropertyData } from "../../../utils/dwHelpers";
import { Form, Button, Accordion, Card } from "react-bootstrap";
import { useStore } from "../../../providers/AppProvider";
import { IFieldFilter, ITimeFilter, MapLayer } from "../../../deckgl/MapLayer";
import { DWEntityLayer, DWQueryConfig } from "../../../deckgl/DWEntityLayer";
import GLMapLayer from "./GLMapLayer";
import { dwConfigs } from "../lib/plantDwConfig";
import { Field } from "../../../types/types";
import { SETTING_SEASON_YEAR } from "../../../utils/settings";
import { Definition } from "../../../../../data/Definition";
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { none } from "ol/centerconstraint";
import HistogramPlots from "./HistogramPlots";

interface Prop {
    field: Field,
    addMapLayers: (layers: MapLayer[]) => void,
    clearMapLayers: () => void,
    refresh: () => void,
    dwAndRasterTimelineDate: string | null,
    dwAndRasterTimelineDateComplete: boolean,
    visibleDW: boolean,
    setVisibleDW: Function,
    addMapLayer: Function,
    removeMapLayer: Function,
};

const GLMapLayers = ({ field, addMapLayers, clearMapLayers, refresh, dwAndRasterTimelineDate, dwAndRasterTimelineDateComplete, setVisibleDW, visibleDW, addMapLayer, removeMapLayer }: Prop) => {
    const { state, settings } = useStore();
    const [mapLayers, setMapLayer] = useState<MapLayer[]>([]);
    const [selectedLayerName, setSelectedLayerName] = useState<string | null>(null);
    const [selectedLayerId, setSelectedLayerId] = useState<string | null>(null);
    const [selectedFieldId, setSelectedFieldId] = useState<number | undefined>(undefined);
    const [updateHistogramId, setUpdateHistogramId] = useState<number>(1);
    const [updateFilterId, setUpdateFilterId] = useState<number>(1);
    const [updateHistogramLoaded, setUpdateHistogramLoaded] = useState<boolean>(false);
    const [histogramConfig, setHistogramConfig] = useState<any>(null);
    const [histogramLoaded, setHistogramLoaded] = useState<boolean>(false);
    const [dwFilters, setDwFilters] = useState<any>({});
    const [presentEntityPropsData, setPresentEntityPropsData] = useState<any>(null);
    const [colorRampMaxMin, setColorRampMaxMin] = useState<Array<number> | null>(null);
    const [awaitedLayerUpdate, setAwaitedLayerUpdate] = useState<number>(0);

    useEffect(() => {
        return () => {
            clearMapLayers();
        };
    }, []);

    useEffect(() => {
        console.log("H111822 mapLayers", mapLayers);
        setHistogramConfig(mapLayers.filter((layer:MapLayer) => {
            if (layer.id === selectedLayerId){
                return layer;
            }
            //layer.load().then(() => refresh());
        })[0])
        setUpdateHistogramId(prev => prev + 1 );
    }, [mapLayers, selectedLayerId]);

    useEffect(() => {
        console.log("A111723 histogramConfig", histogramConfig);
        setUpdateHistogramId(prev => prev + 1 );
    }, [histogramConfig]);

    useEffect(() => {
        setUpdateHistogramId(prev => prev + 1 );
    }, [histogramLoaded]);

    useEffect(() => {
        console.log("053023 useEffect()[field.id] dwAndRasterTimelineDate", dwAndRasterTimelineDate);
        console.log("053023 field.id", field.id );
        console.log("053023 selectedFieldId", selectedFieldId );
        setDwFilters({});
        setUpdateHistogramLoaded(false);
        if(mapLayers.length) {
            if (selectedFieldId === field.id || !selectedFieldId){
                console.log("053023 X");
                mapLayers.forEach((layer: MapLayer) => {
                    const obj = layer as unknown;
                    const filter = obj as IFieldFilter;
                    filter.updateQueryForField(field); 
                    //console.log("C022324 layer", layer);    
                    layer.load().then(() => {
                        console.log("C022324 then layer", layer); 
                        refresh()
                    });
                });
                setUpdateHistogramId(prev => prev + 1 );
            }else{
                console.log("053023 A");
                getDwEntityProps(field, "A", {});
            }
        } else {
            console.log("053023 B");
            getDwEntityProps(field, "B", {});
        }
        setSelectedFieldId(field.id)
    }, [field.id]);

    useEffect(() => {
        const selectedYear = settings[SETTING_SEASON_YEAR];
        if(!selectedYear) {
           return;   
        }
        setDwFilters({});
    },[settings[SETTING_SEASON_YEAR]]);
    
    useEffect(() => {
        console.log("052523 dwAndRasterTimelineDate dwAndRasterTimelineDate", dwAndRasterTimelineDate);
        setUpdateHistogramLoaded(false);
        const selectedYear = settings[SETTING_SEASON_YEAR];
        if(!selectedYear) {
           return;   
        }

        //const dtStart = `${dwAndRasterTimelineDate} 00:00:00.00`;
        //const dtEnd = `${dwAndRasterTimelineDate} 23:59:59.59`;
        console.log("052523 C1", settings[SETTING_SEASON_YEAR]);
    },[settings[SETTING_SEASON_YEAR], dwAndRasterTimelineDate]);

    useEffect(() => {
        console.log("052523 dwAndRasterTimelineDate dwAndRasterTimelineDate", dwAndRasterTimelineDate);
        setUpdateHistogramLoaded(false);
        const selectedYear = settings[SETTING_SEASON_YEAR];
        if(!selectedYear) {
           return;   
        }

        //const dtStart = `${dwAndRasterTimelineDate} 00:00:00.00`;
        //const dtEnd = `${dwAndRasterTimelineDate} 23:59:59.59`;
        console.log("052523 C2", dwAndRasterTimelineDate);
        getDwEntityProps(field, "C2");
        /*mapLayers.forEach((layer: MapLayer) => {
            const obj = layer as unknown;
            const timeFilter = obj as ITimeFilter;

            if(timeFilter.updateQueryForTime) {
                timeFilter.updateQueryForTime(dtStart, dtEnd);     
                layer.load().then((response) => {
                    refresh();
                    setUpdateHistogramLoaded(true);
                });
            }
        });*/
    },[dwAndRasterTimelineDate]);

    useEffect(() => {
        console.log("060123 dwFilters", dwFilters);
        setUpdateHistogramLoaded(false);
        console.log("052523 E");
        getDwEntityProps(field, "E"); 
    },[dwFilters]);

    const getDwEntityProps = async (f: Field, context:string, _dwFilters?:any): Promise<any> => {
        let entityPropsData:any = null; 
        console.log("B021424 getDwEntityProps() ------------------")
        console.log("021524 f before", f)
        console.log("B021424 context", context)
        console.log("B021424 dwAndRasterTimelineDateComplete", dwAndRasterTimelineDateComplete)
        console.log("A052523 field.entityId", field.entityId)
        console.log("E112123 dwFilters", dwFilters)
        console.log("E112123 _dwFilters", _dwFilters)
        let __dwFilters = _dwFilters ? _dwFilters : dwFilters;
        console.log("A052523 dwAndRasterTimelineDate", dwAndRasterTimelineDate)
        console.log("A052523 state.definitions", state.definitions)
        let entityPropsDataRowCol:any = null; 
        console.log("context", context)
        if(field.entityId && dwAndRasterTimelineDate && dwAndRasterTimelineDate !== "no dates available" && dwAndRasterTimelineDateComplete){
            if (context === "E"){
                const dwLayers = filterDwLayers(field, presentEntityPropsData, __dwFilters, mapLayers, false)
                console.log("dwLayers", dwLayers)
                if(!dwLayers.length) {
                    return;
                }

                const layers = [...dwLayers];
                if (selectedLayerId === null){
                    setSelectedLayerName(layers[0]._name);
                    setSelectedLayerId(layers[0].id);
                }else{
                    let _layer = layers.filter((layer:MapLayer) => {
                        if (layer._name === selectedLayerName){
                            return layer;
                        }
                    })[0];
                    setSelectedLayerName(_layer._name);
                    setSelectedLayerId(_layer.id);
                }
                clearMapLayers();
                setMapLayer(layers);
                addMapLayers(layers);
                refresh();
                setUpdateHistogramId(prev => prev + 1 );
                return presentEntityPropsData;
            }else{
                let definition = state.definitions.find((d:Definition) => d.name.toLowerCase().includes('plant'));
                if (!definition){
                    definition = state.definitions.find((d:Definition) => d.name.toLowerCase().includes('tree'));
                }
                //if(state.definitions.length > 2) {
                let definitionNames = state.definitions.map((d:Definition) => d.name.toLowerCase());
                console.log("state.definitions", state.definitions)
                console.log("definitionNames", definitionNames)
                console.log("field (f)", f)
                if (definitionNames.includes('vine') || definitionNames.includes('tree')){
                    if(f.crop?.name.toLocaleLowerCase() === 'grapes') {
                        definition = state.definitions.find((d:Definition) => d.name.toLowerCase().includes('vine'));
                    } else if(f.crop?.name.toLocaleLowerCase() === 'almonds') {
                        definition = state.definitions.find((d:Definition) => d.name.toLowerCase().includes('tree'));
                    }
                }
                console.log("X022823 definition (at B)", definition);
                if(!definition) {
                    console.error('X022823 Unable to find field definition (at B)');
                    return null;
                }else{
                    const selectedYear = settings[SETTING_SEASON_YEAR];
                    //const dtStart = `${selectedYear}-01-01 00:00:00.00`;
                    //const dtEnd = `${selectedYear}-12-31 23:59:59.59`;
                    const dtStart = `${dwAndRasterTimelineDate} 00:00:00.00`;
                    const dtEnd = `${dwAndRasterTimelineDate} 23:59:59.59`;
                    console.log("052523 dtStart",dtStart)
                    console.log("052523 dtEnd",dtEnd)
                    console.log("062923 definition", definition)
                    console.log("021524 f", f)
                    //console.log("062923 field.entityId, definition, 'metric', dtStart, dtEnd, dwFilters", field.entityId, definition, "metric", dtStart, dtEnd, dwFilters)
                    // 021524 
                    console.log("062923 Bloom Index detected in definition:", definition.property.find((e:any) => e.name === "Bloom Index"))
                    console.log("B021424 dtStart, dtEnd", dtStart, dtEnd, context)
                    let _fieldId = field.entityId
                    let _definition = definition
                    Promise.all([
                        queryDwLayerBloomPropertyData(_fieldId, _definition, "metric", dtStart, dtEnd, __dwFilters),
                        queryDwLayerCultivarPropertyData(_fieldId, _definition, "metric", dtStart, dtEnd, __dwFilters),
                        queryDwLayerStatusData(_fieldId, _definition, "metric", dtStart, dtEnd, __dwFilters),
                        queryDwLayerTreatmentPropertyData(_fieldId, _definition, "metric", dtStart, dtEnd, __dwFilters),
                        queryDwLayerCanopyPropertyData(_fieldId, _definition, "metric", dtStart, dtEnd, __dwFilters),
                        queryDwLayerRowCol(_fieldId, _definition, "metric", dtStart, dtEnd, __dwFilters),
                        queryDwLayerVigorPropertyData(_fieldId, _definition, "metric", dtStart, dtEnd, __dwFilters),
                        queryDwLayerPigmentPropertyData(_fieldId, _definition, "metric", dtStart, dtEnd, __dwFilters),
                        queryDwLayerHeightPropertyData(_fieldId, _definition, "metric", dtStart, dtEnd, __dwFilters)
                    ]).then(([
                        dataBloom, dataCultivar, dataStatus, dataTreatment, dataCanopy, dataRowCol, dataVigor, dataPigment, dataHeight
                    ]) => {
                        console.log("A022624 dataBloom (bloom index)", dataBloom);
                        console.log("A022624 dataCultivar (Cultivar)", dataCultivar);
                        console.log("A022624 dataStatus (status)", dataStatus);
                        console.log("A022624 dataTreatment (treatment color)", dataTreatment);
                        console.log("A022624 dataCanopy (canopyarea, canopyvolume)", dataCanopy);
                        console.log("A022624 dataRowCol (row,col)", dataRowCol);
                        console.log("A022624 dataVigor (vigor)", dataVigor);
                        console.log("A022624 dataPigment (pigment)", dataPigment);
                        console.log("A022624 dataHeight (height)", dataHeight);

                        const entityPropsData = {
                            "bloomData": dataBloom,
                            "cultivarData": dataCultivar,
                            "treatmentData": dataTreatment,
                            "canopyData": dataCanopy,
                            "statusData": dataStatus,
                            "rowColData": dataRowCol,
                            "vigorData": dataVigor,
                            "pigmentData": dataPigment,
                            "heightData": dataHeight,
                        };

                        setPresentEntityPropsData(dataBloom);
                        console.log("A022624 entityPropsData", entityPropsData);

                        const dwLayers = createDwLayers(field, entityPropsData, __dwFilters, dataRowCol);
                        console.log("dwLayers", dwLayers);

                        if (!dwLayers.length) {
                            return;
                        }

                        const layers = [...dwLayers];
                        if (selectedLayerId === null) {
                            setSelectedLayerName(layers[0]._name);
                            setSelectedLayerId(layers[0].id);
                        } else {
                            let _layer = layers.filter((layer:MapLayer) => {
                                if (layer._name === selectedLayerName){
                                    return layer;
                                }
                            })[0];
                            setSelectedLayerName(_layer._name);
                            setSelectedLayerId(_layer.id);
                        }

                        setMapLayer(layers);
                        addMapLayers(layers);
                        setUpdateHistogramId(prev => prev + 1);
                    }).catch(error => {
                        console.error("Error executing queries", error);
                    });

                    console.log("xxx entityPropsData", entityPropsData)
                    return entityPropsData;
                    // 021524 
                }
            }
        }else{
            if (dwAndRasterTimelineDate === "no dates available"){
                setHistogramConfig(null);
                //const dwLayers = filterDwLayers(field, presentEntityPropsData, dwFilters, mapLayers, true)
                //console.log("dwLayers", dwLayers)
                const layers:any = [];
                clearMapLayers();
                setMapLayer(layers);
                addMapLayers(layers);
                refresh();
                setUpdateHistogramId(prev => prev + 1 );
            }
            return null;
        }
    }

    const createDwLayers = (f: Field, dwEntityProps:any, dwFilters:any, dataRowCol:any): MapLayer[] => {
        let queryGeojson = {};
        const layers = dwConfigs.map((config: DWQueryConfig, index:number) => {
            console.log("B021924 config", config);
            //let configModified = config;
            //configModified.properties = configModified.properties.filter((prop:any) => (prop.title !== "Canopy Volume")) 
            console.log("G021524 config", config);
            console.log("G021524 dwEntityProps", dwEntityProps);
            console.log("C022823 state.definitions", state.definitions);
            // Figure out which configs to include in this map:
            //
            let defNames = config.definitionName;
            if(f.crop?.name.toLocaleLowerCase() === 'grapes') {
                defNames = ['vine'];
            } else if(f.crop?.name.toLocaleLowerCase() === 'almonds') {
                defNames = ['tree'];
            }
           let layerNames = [
                'Bloom Index (color, radius)',
                'Treatment (color)', 
                'Vigor (color), Canopy Volume (radius)',
                'Pigment (color), Canopy Volume (radius)',
                'Vigor (color), Plant Height (height)', 
                'Cultivar'
            ]
            config.definitionName = defNames;
            let defName = defNames.find(name => {
                return state.definitions.find((d:Definition) => d.name.toLowerCase() == name.toLowerCase()) !== undefined;
            });
            if(!defName) { // To solve for scenario caused by the above hack (above) to draw defNames from 'grapes' or 'almond' crop.name values. If switching from an org with different entity type (e.g., Windfall / 'vine', the definition needs to be switched back to plant.)
               let reinstatePlant = state.definitions.find((d:Definition) => d.name.toLowerCase() == 'plant');
               if (reinstatePlant && reinstatePlant.name){ defName = reinstatePlant.name }
            }
            if(!defName) {
                return null;
            }
            const definition = state.definitions.find((d:Definition) => d.name.toLowerCase() == defName?.toLowerCase()) as Definition;
            console.log("021524 definition", definition);
            console.log("021524 config.title", config.title);
            if ((config.title === 'Bloom Index (color, radius)') && (!definition.property.find((e:any) => e.name === "Bloom Index"))){
                return null;
            };
            if ((config.title === 'Treatment (color)') && (!definition.property.find((e:any) => e.name === "treatment color"))){
                return null;
            };
            if ((config.title === 'Cultivar') && (!definition.property.find((e:any) => e.name.toLowerCase() === "cultivar"))){
                return null;
            };
            if ((config.title === 'Vigor (color), Canopy Volume (radius)') 
                && ((!definition.property.find((e:any) => e.property.toLowerCase() === "canopyvolume"))
                || (!definition.property.find((e:any) => e.property.toLowerCase() === "vvi")))){
                    return null;
            };
            if ((config.title === 'Pigment (color), Canopy Volume (radius)') 
                && ((!definition.property.find((e:any) => e.property.toLowerCase() === "canopyvolume"))
                || (!definition.property.find((e:any) => e.property.toLowerCase() === "pgi")))){
                    return null;
            };
            if ((config.title === 'Vigor (color), Plant Height (height)') 
                && ((!definition.property.find((e:any) => e.property.toLowerCase() === "height"))
                || (!definition.property.find((e:any) => e.property.toLowerCase() === "vvi")))){
                    return null;
            };

            let preNullTheGeojson = false;

            switch (config.title) {
                case 'Vigor (color), Plant Height (height)': // heightData, vigorData
                    if ((!dwEntityProps.heightData) || (Object.keys(dwEntityProps.heightData).length <= 0)) {
                        preNullTheGeojson = true;
                    }
                    if ((!dwEntityProps.vigorData) || (Object.keys(dwEntityProps.vigorData).length <= 0)) {
                        preNullTheGeojson = true;
                    }
                    break;
                case 'Pigment (color), Canopy Volume (radius)': // canopyData, pigmentData
                    if ((!dwEntityProps.canopyData) || (Object.keys(dwEntityProps.canopyData).length <= 0)) {
                        //preNullTheGeojson = true;
                    }
                    if ((!dwEntityProps.pigmentData) || (Object.keys(dwEntityProps.pigmentData).length <= 0)) {
                        preNullTheGeojson = true;
                    }
                    break;
                case 'Vigor (color), Canopy Volume (radius)':
                    if ((!dwEntityProps.canopyData) || (Object.keys(dwEntityProps.canopyData).length <= 0)) {
                        preNullTheGeojson = true;
                    }
                    if ((!dwEntityProps.vigorData) || (Object.keys(dwEntityProps.vigorData).length <= 0)) {
                        preNullTheGeojson = true;
                    }
                    break;
                case 'Cultivar':
                    if ((!dwEntityProps.cultivarData) || (Object.keys(dwEntityProps.cultivarData).length <= 0)) {
                        preNullTheGeojson = true;
                    }
                    break;
                case 'Treatment (color)':
                    if ((!dwEntityProps.treatmentData) || (Object.keys(dwEntityProps.treatmentData).length <= 0)){
                        preNullTheGeojson = true;
                    }
                    break;
                case 'Bloom Index (color, radius)':
                    if ((!dwEntityProps.bloomData) || (Object.keys(dwEntityProps.bloomData).length <= 0)) {
                        preNullTheGeojson = true;
                    }
                    break;
                default:
                    console.log("Unknown layer");
            }
            
            console.log("G021524 preNullTheGeojson", preNullTheGeojson);
            
            console.log("C022823 definition for config", definition, config);
            console.log("E022823 dwFilters", dwFilters);
            console.log("B021924 dwEntityProps", dwEntityProps);
            
            const layer = new DWEntityLayer(index, nanoid(8), config.title, config.visible, config, state.definitions, dwEntityProps, dataRowCol, setHistogramLoaded, dwFilters, queryGeojson, preNullTheGeojson);
            //queryGeojson
            console.log("B022324 layer", layer);
            layer.updateQueryForField(field);
            layer.updatePointRadiusForField(field);

            const selectedYear = settings[SETTING_SEASON_YEAR];
            if(selectedYear) {
                //const dtStart = `${selectedYear}-01-01 00:00:00.00`;
                //const dtEnd = `${selectedYear}-12-31 23:59:59.59`;
                if (dwAndRasterTimelineDate){
                    const dtStart = `${dwAndRasterTimelineDate} 00:00:00.00`;
                    const dtEnd = `${dwAndRasterTimelineDate} 23:59:59.59`;
                    layer.updateQueryForTime(dtStart, dtEnd);     
                }
            }
            //console.log("layer", layer);
            return layer;
        }) as MapLayer[];

        return layers.filter((layer) => layer != null);
    }

    const filterDwLayers = (f: Field, dwEntityProps:any, dwFilters:any,mapLayers:MapLayer[], clearHistograms:boolean): MapLayer[] => {
        const layers = mapLayers.map((layer: MapLayer) => {
            console.log("x032423 x layer", layer);
            let layer2 = layer as DWEntityLayer;
            layer2.getTransform(dwFilters).then(function(response:any) {
                console.log("x032423 x response", response);
                //setUpdateFilterId(prev => prev + 1 );
                //setHistogramConfig(
                let mapLayersX = mapLayers.map((layerM:MapLayer) => {
                    console.log("052523 x layerM", layerM);
                    //if (layer.id === selectedLayerId){
                    //    return layer;
                    //}
                    //layer.load().then(() => refresh());
                    let layer = layerM as DWEntityLayer;
                    if ((layer._name === response[5]?.title) && !clearHistograms){
                        if (clearHistograms){
                            layer._histogramData.histogramData = null;
                        }else{
                            layer._histogramData.histogramData = response[4].histogramData
                            //setUpdateHistogramId(prev => prev + 1 );
                            if (selectedLayerName === layer._name){                        
                                console.log("x032423 x ----> layerM", layerM);
                                console.log("x032423 x ----> response", response);
                                setColorRampMaxMin( response.find((e:any) => e.hasOwnProperty('colorRampMaxMin')) ? response.find((e:any) => e.hasOwnProperty('colorRampMaxMin')).colorRampMaxMin : null);
                            }
                        }
                    }
                    return layer as MapLayer;
                })
                setMapLayer(mapLayersX);
               // )
                //setColorRampMaxMin( response.find((e:any) => e.hasOwnProperty('colorRampMaxMin')) ? response.find((e:any) => e.hasOwnProperty('colorRampMaxMin')).colorRampMaxMin : null);
            });
            //layer2._id = nanoid(8);
            console.log("x032423 x layer2", layer2);
            /*const layers = dwConfigs.map((config: DWQueryConfig) => {
            //console.log("config", config);
            //let configModified = config;
            //configModified.properties = configModified.properties.filter((prop:any) => (prop.title !== "Canopy Volume")) 
            console.log("X111722 config", config);
            const layer = new DWEntityLayer(nanoid(8), config.title, config.visible, config, state.definitions, dwEntityProps, setHistogramLoaded, dwFilters);
            
            layer.updateQueryForField(field);
            layer.updatePointRadiusForField(field);

            const selectedYear = settings[SETTING_SEASON_YEAR];
            if(selectedYear) {
                //const dtStart = `${selectedYear}-01-01 00:00:00.00`;
                //const dtEnd = `${selectedYear}-12-31 23:59:59.59`;
                if (dwAndRasterTimelineDate){
                    const dtStart = `${dwAndRasterTimelineDate} 00:00:00.00`;
                    const dtEnd = `${dwAndRasterTimelineDate} 23:59:59.59`;
                    layer.updateQueryForTime(dtStart, dtEnd);     
                }
            }
            //console.log("layer", layer);*/
            return layer2 as MapLayer;
        }) as MapLayer[];

        return layers.filter((layer) => layer != null);
    }

    const onGLLayerSourceChange = (e: any) => {
        if(!mapLayers) return;
        let _layer = mapLayers.filter((layer:MapLayer) => {
            if (layer.id === e.target.value){
                return layer;
            }
        })[0];
        setSelectedLayerName(_layer._name);
        setSelectedLayerId(e.target.value);
    }
    function handleAccordionClick(event:any) {
        console.log('onClick', event);
    };

    return (
        <>
        { mapLayers.length 
        ? <div className="d-flex flex-column mb-2 border p-2 rounded">
            <div className="mt-3">
                <Form.Check 
                    type="checkbox"
                    label="Plant DVS"
                    checked={visibleDW}
                    onChange={() => {
                        const nextState = !visibleDW;

                        setVisibleDW(nextState);
                        refresh();
                    }}
                />
                <div className="d-flex mt-3">
                    <Form.Control as="select"
                        size="sm"
                        onChange={(e: any) => onGLLayerSourceChange(e)}
                        value={selectedLayerId ? selectedLayerId : undefined}>
                        { mapLayers.length < 1 
                            ? <option key={"none"} value={undefined}>No layers available</option>
                            : mapLayers.map((source:any, index:number)=> (
                                    <option key={`${source.id}_${index}`} value={source.id}>{source.name}</option>
                                ))
                            }
                    </Form.Control>
                </div>
                <ul className="list-unstyled text-sm" style={{marginBottom: "0px" }}>
                    {mapLayers.map((layer: MapLayer, index:number) => (
                        //console.log("C022324 layer", layer),
                        <li key={layer.id}>
                            <GLMapLayer 
                                awaitedLayerUpdate={awaitedLayerUpdate} 
                                setAwaitedLayerUpdate={setAwaitedLayerUpdate}
                                index={index} 
                                layer2={layer as DWEntityLayer} 
                                layer={layer} 
                                onChange={refresh}
                                visibleSelection={visibleDW}
                                selectedLayerId={selectedLayerId}
                                setSelectedLayerId={setSelectedLayerId}
                                setUpdateHistogramId={setUpdateHistogramId}
                                setUpdateHistogramLoaded={setUpdateHistogramLoaded}
                                updateHistogramId={updateHistogramId}
                                updateHistogramLoaded={updateHistogramLoaded}
                                dwFilters={dwFilters}
                                colorRampMaxMin={colorRampMaxMin}
                                setColorRampMaxMin={setColorRampMaxMin}
                            />
                        </li>
                    ))}
                </ul>
                <HistogramPlots
                    field={field}
                    config={histogramConfig}
                    selectedLayerId={selectedLayerId}
                    updateHistogramId={updateHistogramId}
                    updateHistogramLoaded={updateHistogramLoaded}
                    dwFilters={dwFilters}
                    setDwFilters={setDwFilters} 
                    //onClick={onPlotClick}
                />
            </div>
        </div>
        :<></>
        }
        </>
    );
}

export default GLMapLayers;